export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/expandToHashMap.js
// module id = null
// module chunks = 